module.exports = [{"name":"GUARD_GUARD2366","version":1}]